module.exports = __webpack_public_path__ + "03362a3f3b64d9ab76407d2f4f6f857f.png";